import { Control } from "react-hook-form";
import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";
import Grid from "@mui/material/Grid";
import InputFormField from "components/input-form-field";

export type TubeSpecificationValues = {
  additional_notes: string;
  size?: string;
};

export const EMPTY_TUBE_SPECIFICATION: TubeSpecificationValues = {
  additional_notes: "",
  size: "",
};

type TubeSpecificationFormProps = {
  control: Control<InventoryProductSpecificationValues, object>;
};

export default function TubeSpecificationForm({
  control,
}: TubeSpecificationFormProps) {
  return (
    <Grid
      container
      width="100%"
      sx={{ pb: 4 }}
      columnSpacing={2}
      rowSpacing={4}
    >
      <Grid item xs={6}>
        <InputFormField
          name="tube.size"
          label="Size"
          control={control}
          sx={{ ml: 0 }}
        />
      </Grid>
      <Grid item xs={12}>
        <InputFormField
          name="tube.additional_notes"
          label="Additional notes"
          control={control}
          sx={{ ml: 0 }}
          multiline
        />
      </Grid>
    </Grid>
  );
}
